const mediaFields = { articleCoverImage: 'articleCoverImageFileId', articleThumbnail: 'articleThumbnailFileId', articleVideo: 'articleVideoFileId' }
const idOf = value => {
  const id = typeof value === 'string' ? value : value && value._id
  return typeof id === 'string' && /^[a-f0-9]{24}$/i.test(id) ? id : undefined
}
const localized = (value, lang) => (value && typeof value === 'object' && !value._id ? value[lang] : value)

export function restoreVideoReferences(form, original) {
  const result = { ...form }
  Object.entries({
    approver: 'approverId', editor: 'editorId', category: 'categoryId', ...mediaFields,
  }).forEach(([field, key]) => {
    const saved = mediaFields[field] ? localized(original[key], form.lang) : original[key]
    if (!idOf(result[field]) && idOf(saved)) result[field] = typeof saved === 'object' ? saved : { _id: saved }
  })
  return result
}

export function videoReferencePatch(form, original) {
  const patch = {}
  Object.entries(mediaFields).forEach(([field, key]) => {
    const next = idOf(form[field])
    const previous = idOf(localized(original[key], form.lang))
    // Missing legacy media and unchanged references are not removal requests.
    if (next && next !== previous) patch[key] = next
  })
  Object.entries({ approver: 'approverId', editor: 'editorId', category: 'categoryId' }).forEach(([field, key]) => {
    const next = idOf(form[field])
    if (next) patch[key] = next
    else if (field !== 'category' && form[field] === null && idOf(original[key])) patch[key] = null
  })
  return patch
}

export function videoUploadFields(form, previous) {
  return Object.keys(mediaFields).filter(field => {
    const value = form[field]
    return (typeof File !== 'undefined' && value instanceof File)
      || (idOf(value) && form[`${field}Alt`] !== previous[`${field}Alt`])
  })
}

export const videoEditMessages = {
  fa: {
    slugCurrentAmbiguous: 'این آدرس برای چند مطلب استفاده شده است. آدرس قبلی را نگه دارید و برای مشخص‌شدن مطلب اصلی از مدیر کمک بگیرید؛ اطلاعات فرم حفظ شده است.',
    slugAlreadyOwned: 'این آدرس متعلق به مطلب دیگری است. آدرس دیگری انتخاب کنید و دوباره ذخیره کنید؛ اطلاعات فرم حفظ شده است.',
    pending: 'در حال ذخیره تغییرات…',
    saved: 'تغییرات ذخیره شد.',
    savedWithNewChanges: 'نسخه ارسال‌شده ذخیره شد. تغییرات جدیدتر شما هنوز ذخیره نشده‌اند؛ دوباره ذخیره کنید.',
    invalid: 'تغییرات ذخیره نشد. اطلاعات فرم را بررسی کنید و دوباره ذخیره کنید.',
    denied: 'اجازه ذخیره ندارید یا نشست شما پایان یافته است. پس از ورود دوباره تلاش کنید؛ اطلاعات فرم حفظ شده است.',
    failed: 'ذخیره انجام نشد. اتصال را بررسی کنید و دوباره تلاش کنید؛ اطلاعات فرم حفظ شده است.',
    unknown: 'نتیجه ذخیره مشخص نیست. پیش از ارسال دوباره، وضعیت این ویدئو را در یک تب دیگر بررسی کنید.',
    fields: 'فیلدهای نیازمند بررسی: ',
    labels: {
      articleVideoFileId: 'فایل ویدئو', articleCoverImageFileId: 'تصویر کاور', articleThumbnailFileId: 'تصویر کوچک', approverId: 'تأییدکننده', editorId: 'ویراستار', categoryId: 'دسته‌بندی', slug: 'نامک', title: 'عنوان',
    },
  },
  en: {
    slugCurrentAmbiguous: 'This URL is shared by multiple posts. Keep the previous URL and ask an administrator to resolve ownership; your input is preserved.',
    slugAlreadyOwned: 'This URL belongs to another post. Choose a different URL and save again; your input is preserved.',
    pending: 'Saving changes…',
    saved: 'Changes saved.',
    savedWithNewChanges: 'The submitted version was saved. Your newer edits are not saved yet; save again.',
    invalid: 'Changes were not saved. Check the form and save again.',
    denied: 'Your session expired or you do not have permission. Sign in and try again; your input is preserved.',
    failed: 'Changes were not saved. Check your connection and try again; your input is preserved.',
    unknown: 'The save outcome is unknown. Check this video in another tab before submitting again.',
    fields: 'Fields to check: ',
    labels: {
      articleVideoFileId: 'Video file', articleCoverImageFileId: 'Cover image', articleThumbnailFileId: 'Thumbnail', approverId: 'Approver', editorId: 'Editor', categoryId: 'Category', slug: 'Slug', title: 'Title',
    },
  },
  ar: {
    slugCurrentAmbiguous: 'هذا الرابط مستخدم لأكثر من منشور. احتفظوا بالرابط السابق واطلبوا من المسؤول تحديد المنشور صاحب الرابط؛ بيانات النموذج محفوظة.',
    slugAlreadyOwned: 'هذا الرابط يخص منشورًا آخر. اختاروا رابطًا مختلفًا واحفظوا مجددًا؛ بيانات النموذج محفوظة.',
    pending: 'جارٍ حفظ التغييرات…',
    saved: 'تم حفظ التغييرات.',
    savedWithNewChanges: 'تم حفظ النسخة المرسلة. تعديلاتكم الأحدث لم تُحفظ بعد؛ احفظوا مجددًا.',
    invalid: 'لم تُحفظ التغييرات. راجعوا الحقول ثم احفظوا مجددًا.',
    denied: 'انتهت الجلسة أو ليس لديكم إذن بالحفظ. سجّلوا الدخول وحاولوا مجددًا؛ بيانات النموذج محفوظة.',
    failed: 'لم تُحفظ التغييرات. تحققوا من الاتصال وحاولوا مجددًا؛ بيانات النموذج محفوظة.',
    unknown: 'نتيجة الحفظ غير معروفة. تحققوا من هذا الفيديو في علامة تبويب أخرى قبل الإرسال مجددًا.',
    fields: 'حقول تحتاج إلى مراجعة: ',
    labels: {
      articleVideoFileId: 'ملف الفيديو', articleCoverImageFileId: 'صورة الغلاف', articleThumbnailFileId: 'الصورة المصغّرة', approverId: 'المراجع', editorId: 'المحرر', categoryId: 'التصنيف', slug: 'الرابط المختصر', title: 'العنوان',
    },
  },
}

export function videoSaveError(error, words) {
  const status = error && error.response && error.response.status
  const code = error && error.response && error.response.data && error.response.data.code
  if (status === 409 && code === 'SLUG_CURRENT_AMBIGUOUS') return words.slugCurrentAmbiguous
  if (status === 409 && code === 'SLUG_ALREADY_OWNED') return words.slugAlreadyOwned
  if (status === 401 || status === 403) return words.denied
  if (status === 400 || status === 409 || status === 422) {
    const messages = error.response.data && error.response.data.message
    let text = typeof messages === 'string' ? messages : ''
    if (Array.isArray(messages)) text = messages.filter(value => typeof value === 'string').join(' ')
    const fields = Object.keys(words.labels).filter(key => new RegExp(`\\b${key}\\b`).test(text)).map(key => words.labels[key])
    return words.invalid + (fields.length ? ` ${words.fields}${fields.join('، ')}` : '')
  }
  return words.unknown
}

export async function boundedVideoSave(request, timeoutMs = 15000) {
  let timer
  try { return await Promise.race([request, new Promise((resolve, reject) => { timer = setTimeout(() => reject(new Error('Save acknowledgement timed out')), timeoutMs) })]) } finally { clearTimeout(timer) }
}

// Preserve file objects while isolating the submitted fields from edits during upload.
export function snapshotVideoForm(value) {
  if (!value || typeof value !== 'object' || (typeof File !== 'undefined' && value instanceof File)) return value
  if (Array.isArray(value)) return value.map(snapshotVideoForm)
  return Object.fromEntries(Object.entries(value).map(([key, item]) => [key, snapshotVideoForm(item)]))
}
